import {Response, Task} from "@core/model";
import {ApiBuilder} from "..";

const fetchTasksByRange = (builder: ApiBuilder) =>
  builder.query<Task[], {from: number; to: number}>({
    query: request => ({
      url: `/api/task/range?from=${request.from}&to=${request.to}`,
      method: "GET",
    }),
    transformResponse: (response: Response<Task[]>) => {
      return response.data;
    },
    providesTags: result => (result ? [{type: "task", id: "range"}] : []),
  });

const fetchTasksByAssetId = (builder: ApiBuilder) =>
  builder.query<Task[], string>({
    query: assetId => ({
      url: `/api/task/asset/${assetId}`,
      method: "GET",
    }),
    transformResponse: (response: Response<Task[]>) => {
      return response.data;
    },
    providesTags: (result, _err, assetId) =>
      result ? [{type: "task", id: assetId}] : [],
  });

export {fetchTasksByRange, fetchTasksByAssetId};
